module.exports = __webpack_public_path__ + "static/media/meeting-link-image@2x.dbc5b219.png";